import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { RbtTransitionStatus } from '../../models/rbtTransitionStatus';

@Injectable({ providedIn: 'root' })
export class RbtTransitionService {
  private readonly url = `${environment.apiServer.webApiURL}/RbtTransition`;
  constructor(private http: HttpClient) { }
  getStatus() { return this.http.get<RbtTransitionStatus>(this.url); }
  beginCredentialUpload() { return this.http.post<{ uploadToken: string }>(`${this.url}/BeginCredentialUpload`, {}); }
  saveExamDate(examDate: string) { return this.http.post<RbtTransitionStatus>(`${this.url}/ExamDate`, { examDate }); }
  acknowledgeSignaturePrompt() { return this.http.post<RbtTransitionStatus>(`${this.url}/AcknowledgeSignaturePrompt`, {}); }
}
